import { reportsItems } from "@/consts/Reports";
import { StaffAccessLevels } from "@/enums/StaffAccessLevels";

export default {
  name: "ReportList",
  data() {
    return {
      currentDate: new Date().getDate(),
      search: "",
      reports: [],
      staffAccessLevels: StaffAccessLevels,
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "name"
        }
      ]
    }
  },
  created() {
    const reportsItemsCopy = JSON.parse(JSON.stringify(reportsItems()))

    const reportsByAccess = reportsItemsCopy.filter(x => x.accessLevels?.length ? x.accessLevels.includes(this.user.accessLevel) : true)

    const reportsByFacility = reportsByAccess.filter(this.filterByFacilityPackage);

    this.reports = reportsByFacility.map(x => {
      const r = x
      r.name = this.$i18n.messages[this.$i18n.locale][x.name]
      return r
    });
  },
  methods: {
    openReport(route) {
      this.$router.push("/reports/" + route);
    },

    filterByFacilityPackage(r) {
      const alwaysAllowed = [

        "Reports.OrganisationalHealthDashboard",
        "Reports.CommunityHealthDashboard"
      ];
      if (alwaysAllowed.includes(r.name)) return true;

      if (
        this.showFamilyEngagement &&
        ["Reports.Resident360Report", "Reports.FamilyReport", "Reports.ActivitiesReport"].includes(r.name)
      ) {
        return true;
      }

      if (
        this.showLifestyle &&
        ["Reports.LifestyleProgramsReport", "Reports.LifestyleEventsReport"].includes(r.name)
      ) {
        return true;
      }

      if (
        this.showConcierge &&
        [
          "Reports.PremiumServiceReports",   // Concierge Report
          "Reports.ServiceRequestReport",    // Bookings & Orders Report
        ].includes(r.name)
      ) {
        return true;
      }

      if (this.showMaintenance && r.name === "Reports.Maintenance") {
        return true;
      }

      return false;
    },

  },
  computed: {
    user() {
      return this.$store.state.authModule.user;
    },
    showConcierge(): boolean {
      return this.$store.state.authModule.currentFacilityData.featureConcierge;
    },
    showMaintenance(): boolean {
      return this.$store.state.authModule.currentFacilityData.featureMaintenance;
    },
    showFamilyEngagement(): boolean {
      return this.$store.state.authModule.currentFacilityData.featureFamilyEngagement;
    },
    showLifestyle(): boolean {
      return this.$store.state.authModule.currentFacilityData.featureLifestyle;
    },
    isMaintenanceAdmin() {
      return this.user.accessLevel === StaffAccessLevels.MaintenanceAdmin;
    }
  }
}
